import moment from 'moment-timezone';

// Function to get event date
export const getEventDate = (event) => {
  const currentDate = moment();
  const year = currentDate.year();

  // Calculate Labor Day (first Monday of September)
  let laborDay = moment(`${year}-09-01`);

  // Find the first Monday of September
  while (laborDay.day() !== 1) {
    laborDay.add(1, 'day');
  }

  // Calculate the first weekend AFTER Labor Day
  // Labor Day is Monday, so the following Friday is +4 days, Saturday is +5 days
  const countryEdgeStartDate = laborDay
    .clone()
    .add(4, 'days') // Friday after Labor Day
    .set({ hour: 17, minute: 30 });

  const chilimaniaStartDate = laborDay
    .clone()
    .add(5, 'days') // Saturday after Labor Day
    .set({ hour: 11, minute: 0 });

  // Set the end of Chilimania to midnight
  const chilimaniaEndDate = chilimaniaStartDate.clone().endOf('day');

  // Determine if the current time is past the end of Chilimania
  const isAfterChilimania = currentDate.isAfter(chilimaniaEndDate);

  // If it's past the end of Chilimania, calculate next year's dates
  let finalCountryEdgeDate = countryEdgeStartDate;
  let finalChilimaniaDate = chilimaniaStartDate;

  if (isAfterChilimania) {
    // Calculate next year's Labor Day
    const nextYear = year + 1;
    let nextLaborDay = moment(`${nextYear}-09-01`);

    while (nextLaborDay.day() !== 1) {
      nextLaborDay.add(1, 'day');
    }

    finalCountryEdgeDate = nextLaborDay
      .clone()
      .add(4, 'days')
      .set({ hour: 17, minute: 30 });

    finalChilimaniaDate = nextLaborDay
      .clone()
      .add(5, 'days')
      .set({ hour: 11, minute: 0 });
  }

  // Return the appropriate event date
  if (event === 'countryEdge') {
    return finalCountryEdgeDate
      .tz('America/Chicago')
      .format('YYYY-MM-DD HH:mm:ss');
  } else if (event === 'chilimania') {
    return finalChilimaniaDate
      .tz('America/Chicago')
      .format('YYYY-MM-DD HH:mm:ss');
  }
};
